module.exports = __webpack_public_path__ + "img/truck-performance-selected.57a80701.svg";